import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarOffSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarOffSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarOffSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarOffSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DollarOffSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M1.05 1.05l9.9 9.9-.707.707L8.47 9.883A.996.996 0 018 10H7v1H5v-1H4a1 1 0 01-1-1V8h1v.7a.3.3 0 00.3.3h3.286l-3-3H4a1 1 0 01-1-1v-.587L.342 1.757l.707-.707zM8 5a1 1 0 011 1v1.586l-1-1V6.3a.3.3 0 00-.3-.3h-.286l-1-1H8zM7 1v1h1a1 1 0 011 1v1H8v-.7a.3.3 0 00-.3-.3H4.414l-.883-.883C3.67 2.042 3.83 2 4 2h1V1h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DollarOffSmallIcon.displayName = "DollarOffSmallIcon";
export default DollarOffSmallIcon;
